import { render, staticRenderFns } from "./RattachmentCard.vue?vue&type=template&id=4837c4f8"
import script from "./RattachmentCard.vue?vue&type=script&lang=js"
export * from "./RattachmentCard.vue?vue&type=script&lang=js"
import style0 from "./RattachmentCard.vue?vue&type=style&index=0&id=4837c4f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports